import { api } from '@/api/api'
import { useQuery } from '@tanstack/react-query'

interface PremioLojaItem {
  id: string
  criadoEm: string
  atualizadoEm: string
  nome: string
  descricao: string
  valorEmPontos: number
  estoque: number
  ativo: number
  limitePorAluno: number
  fornecedorId: string
  criadoPor: string
  categoriaPremiosId: string
  subcategoriaPremiosId: string
  tipoResgate: string
  resgatado: number
  ranking_id: number
  tipoRanking: string
  ranking_cadastradoPorId: string
  posicaoRanking: number
  ranking_posicaoFinal: number
  ranking_criadoEm: string
  ranking_atualizadoEm: string
  ranking_cidade: string | null
  ranking_instituicaoId: string | null
  ranking_turmaId: string | null
  arquivo_id: string
  arquivo_criadoEm: string
  arquivo_atualizadoEm: string
  arquivo_caminho: string
  arquivo_nomeOriginal: string
  categoria_id: string
  categoria_nome: string
  categoria_descricao: string
  categoria_criadoEm: string
  categoria_atualizadoEm: string
  subcategoria_id: string
  subcategoria_nome: string
  subcategoria_descricao: string
  subcategoria_categoriaId: string
  subcategoria_criadoEm: string
  subcategoria_atualizadoEm: string
}

interface PremioLojaFilters {
  skip?: number
  take?: number
  // Filtros de categoria
  categoriaPremiosId?: string
  // Filtros de valor
  valorMinimo?: number
  valorMaximo?: number
  // Filtros de disponibilidade
  premioDisponivel?: boolean
  // Filtros de ranking
  tipoResgate?: 'PONTOS' | 'RANKING'
  rankingTipo?: 'geral' | 'cidade' | 'escola' | 'turma'
  posicaoRankingMin?: number
  posicaoRankingMax?: number
  // Filtros de ordenação
  orderBy?: 'nome' | 'valorEmPontos'
  orderDirection?: 'asc' | 'desc'
  // Filtros de busca
  nome?: string
  // Filtros de estoque e resgate
  isEstoque?: boolean
  isResgatado?: boolean
}

interface PremioLojaResponse {
  data: {
    count: number
    data: PremioLojaItem[]
  }
}

export const usePrêmiosLoja = (filters: PremioLojaFilters = {}) => {
  return useQuery({
    queryKey: ['premios-loja', filters],
    queryFn: async (): Promise<PremioLojaResponse> => {
      return await premiosLojaListar(filters)
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}

async function premiosLojaListar(
  filters: PremioLojaFilters = {},
): Promise<PremioLojaResponse> {
  const headers: Record<string, string> = {}
  const params = new URLSearchParams()

  // Add pagination parameters to URL
  if (filters.skip !== undefined) params.append('skip', filters.skip.toString())
  if (filters.take !== undefined) params.append('take', filters.take.toString())

  // Add filter headers
  const whereFilters: any = {}

  // Categoria e valores
  if (filters.categoriaPremiosId)
    whereFilters.categoriaPremiosId = filters.categoriaPremiosId
  if (filters.valorMinimo !== undefined)
    whereFilters.valorMinimo = filters.valorMinimo
  if (filters.valorMaximo !== undefined)
    whereFilters.valorMaximo = filters.valorMaximo

  // Status do prêmio
  if (filters.premioDisponivel !== undefined)
    whereFilters.premioDisponivel = filters.premioDisponivel
  if (filters.isEstoque !== undefined)
    whereFilters.isEstoque = filters.isEstoque
  if (filters.isResgatado !== undefined)
    whereFilters.isResgatado = filters.isResgatado

  // Tipo e ranking
  if (filters.tipoResgate) whereFilters.tipoResgate = filters.tipoResgate
  if (filters.rankingTipo) whereFilters.rankingTipo = filters.rankingTipo
  if (filters.posicaoRankingMin !== undefined)
    whereFilters.posicaoRankingMin = filters.posicaoRankingMin
  if (filters.posicaoRankingMax !== undefined)
    whereFilters.posicaoRankingMax = filters.posicaoRankingMax

  // Ordenação e busca
  if (filters.orderBy) whereFilters.orderBy = filters.orderBy
  if (filters.orderDirection)
    whereFilters.orderDirection = filters.orderDirection
  if (filters.nome) whereFilters.nome = filters.nome

  // Adiciona o header 'where' com todos os filtros
  if (Object.keys(whereFilters).length > 0) {
    headers.where = JSON.stringify(whereFilters)
  }

  const url = `/autenticado/premio/aluno/loja${params.toString() ? `?${params.toString()}` : ''}`

  console.log('headers', headers)

  const result = await api().get(url, {
    headers,
  })

  return result.data
}
